import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Cookie from "js-cookie";
//import { resolve, reject } from 'core-js/fn/promise'
import api from "./api";

import faunadb, { query as q } from "faunadb";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: '',
    authStatus: null, //"indicated", "pending", "token", "failed"
    user : {},
    profile: null,
    loading: false
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_requested(state){
      state.authStatus = "pending"
      state.status = 'verification email sent'
    },
    auth_check(state){
      state.authStatus = "indicated"
      state.status = 'checking'
    },
    auth_success(state, token, user={}){
      state.status = 'success'
      state.token = token
      state.user = user
      state.authStatus = "token"
    },
    auth_error(state){
      state.status = 'error'
      state.authStatus = "failed"
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.authStatus = null
      state.user = {}
    },
    set_user(state, user){
      state.user = user;
    },
    set_profile(state, profile) {
      state.profile = profile;
      state.user.artistProfile = profile;
    },
    set_loading(state, data) {
      state.loading = data || true;
    }
  },
  actions: {
    login({commit}, user){
      return new Promise((resolve, reject) => { //eslint-disable-line no-unused-vars
        commit("auth_request")
        axios({url: "/api/user/login", data: user, method: "POST" })
        .then(resp => {
          if(resp.data.result.indexOf("email sent") > -1) {
            commit("auth_requested");
          } else {
            commit("auth_error");
          }
          resolve(resp)
        })
        .catch(err => {
          commit("auth_error")
          reject(err)
        })
      })
    },
    logout({commit}){
      return new Promise((resolve, reject) => { //eslint-disable-line no-unused-vars
        Cookie.remove("authed");
        axios.get("/api/user/logout")
          .then((res) => {
              if(res.data.success) {
                commit("logout");
                resolve(res);
              } else {
                reject("Logout failed");
              }
          })
          .catch((error) => {
              reject(error);
          });
      });
    },
    authenticate({commit, dispatch}, authCode) {
      commit("auth_request");
      return dispatch("api/get", "user/authenticate?auth_code=" + authCode).
        then((res) => {
          commit("auth_success", res.data.token);
          return dispatch("load_user");
        });
    },
    verify_auth({commit, dispatch}) {
        commit("auth_check");
        return dispatch("api/get","user/verify")
          .then((res) => {
              //Perform Success Action
              if(res.data.authenticated) {
                commit("auth_success", res.data.token);
                return res;
              } else {
                commit("auth_error");
              }
              //this.user = {};
          })
    },
    load_user({commit}) {
      return new Promise((resolve, reject) => {
        axios.get("/api/user/me")
          .then((res) => {
            commit("set_user", res.data);
            resolve(res.data);
          }).catch((error) => {
            // error.response.status Check status code
            console.log(error); // eslint-disable-line no-console
            //commit("auth_error");
            reject(error);
        });
      })
    },
   async save_profile({state, commit}, data) {
      commit('set_loading', "profile");
      const token = state.token;
      const client = new faunadb.Client({ secret: token });
      console.log(data);
      try {
          let res = await client.query(q.Call('saveProfile', data));
          console.log(res);
          commit('set_profile', res.data);
          return res.data;
      } catch(err) {
          // catch
          console.log(err.message);
      }
}
  },
  getters: {
    isAuthenticated: state => {
      return state.authStatus == "token";
    },
    hasProfile: state => {
      return !!state.user.artistProfile;
    },
    getProfile: state => {
      return (state.user || {artistProfile: {}}).artistProfile;
    }
  },
  modules: {
    api
  }
})
